module.exports = __webpack_public_path__ + "static/media/07-multi.3a6a9925.png";